'use client';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { subscribeToQuery, } from 'datocms-listen';
import { useState } from 'react';
import { useDeepCompareEffectNoCheck as useDeepCompareEffect } from 'use-deep-compare-effect';
export function useQuerySubscription(options) {
    const { enabled, initialData } = options, other = __rest(options, ["enabled", "initialData"]);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const [status, setStatus] = useState(enabled ? 'connecting' : 'closed');
    const subscribeToQueryOptions = other;
    useDeepCompareEffect(() => {
        if (enabled === false) {
            setStatus('closed');
            return () => {
                // we don't have to perform any uninstall
            };
        }
        let unsubscribe;
        function subscribe() {
            return __awaiter(this, void 0, void 0, function* () {
                unsubscribe = yield subscribeToQuery(Object.assign(Object.assign({}, subscribeToQueryOptions), { onStatusChange: (status) => {
                        setStatus(status);
                    }, onUpdate: (updateData) => {
                        setError(null);
                        setData(updateData.response.data);
                    }, onChannelError: (errorData) => {
                        setData(null);
                        setError(errorData);
                    } }));
            });
        }
        subscribe();
        return () => {
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, [subscribeToQueryOptions]);
    return { error, status, data: data || initialData };
}
//# sourceMappingURL=index.js.map